var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
let TestReportElement = class TestReportElement extends Vue {
    constructor() {
        super(...arguments);
        this.checked = false;
        this.clicked = false;
    }
    testReportChanged(e) {
        this.clicked = true;
        return e;
    }
    get elementKey() { return "testReport"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    created() { this.checked = this.value; }
    onValueChanged(val, _oldVal) { this.checked = val; }
};
__decorate([
    Prop({ required: true })
], TestReportElement.prototype, "projectEntry", void 0);
__decorate([
    Prop({ required: true })
], TestReportElement.prototype, "value", void 0);
__decorate([
    Inject()
], TestReportElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], TestReportElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], TestReportElement.prototype, "testReportChanged", null);
__decorate([
    Watch("value")
], TestReportElement.prototype, "onValueChanged", null);
TestReportElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "TestReportElement",
    })
], TestReportElement);
export default TestReportElement;
